import Rect from "react"
import { Backdrop, Box } from "@mui/material"
import PropTypes from "prop-types"
import React, { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import UserListView from "./list"
import ExcelJS from "exceljs"
import { eve } from "react-eve-hook"
import { USER_LIST_IMPORTED } from "../../../Constraints"
import _ from "ansuko"

const styles = {
    root: {
        width: "800px",
        height: "400px",
        maxWidth: "80%",
        maxHeight: "80%",
        position: "relative",
    }
}

const UserView = ({open, onClose}) => {

    const onDrop = useCallback(async (acceptedFiles) => {
        if (acceptedFiles.length === 0) return

        const file = acceptedFiles[0]
        console.log("[User Import] File dropped:", file.name)

        try {
            const arrayBuffer = await file.arrayBuffer()
            const workbook = new ExcelJS.Workbook()
            await workbook.xlsx.load(arrayBuffer)
            
            const sheet = workbook.worksheets[0]
            const importedData = []

            // セルの値を取得するヘルパー関数（ハイパーリンクの場合はtextを取得）
            const getCellValue = (cell) => {
                const value = cell.value
                if (_.isEmpty(value)) { return null }
                // ハイパーリンクオブジェクトの場合はtextプロパティを取得
                if (typeof value === "object" && value.text !== undefined) {
                    return value.text
                }
                return value
            }

            const getCellIntValue = (cell) => {
                const value = getCellValue(cell)
                if (!value) { return null }
                return parseInt(value)
            }

            // ヘッダー行をスキップして、2行目からデータを読み込む
            sheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return // ヘッダー行をスキップ

                const rowData = {
                    cartodb_id: getCellIntValue(row.getCell(1)) || null,
                    name: getCellValue(row.getCell(2)),
                    email: getCellValue(row.getCell(3)),
                    area: getCellValue(row.getCell(4)),
                    newPassword: getCellValue(row.getCell(5)),
                    shouldDelete: getCellValue(row.getCell(6)),
                }

                // 空行をスキップ
                if (!rowData.name && !rowData.email) return

                importedData.push(rowData)
            })



            console.log("[User Import] Imported data:", importedData)
            eve(USER_LIST_IMPORTED, importedData)
            // TODO: importedDataをUserListViewに渡す処理を実装
            // 新規: cartodb_idがnullまたは空のもの
            // 既存: cartodb_idがあるもの

        } catch (error) {
            console.error("[User Import] Error importing file:", error)
            alert("ファイルの読み込みに失敗しました")
        }
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        noClick: true,
        onDrop,
        accept: {
            "text/plain": [".csv"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            "application/vnd.ms-excel": [".xls"],
        }
    })

    return (
        <Backdrop open={open} style={{zIndex: 8000}}>
            <Box style={styles.root}>
                <div {...getRootProps()} style={{ width: "100%", height: "100%", background: "#333", position: "relative"}}>
                    <input {...getInputProps()} />
                    <UserListView onClose={onClose} />
                    {isDragActive && (
                        <Box style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "rgba(0, 0, 0, 0.8)",
                            zIndex: 10000,
                            pointerEvents: "none"
                        }}>
                            <p style={{ color: "white", fontSize: "24px" }}>ここにファイルをドロップ</p>
                        </Box>
                    )}
                </div>
            </Box>
        </Backdrop>
    )

}

UserView.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

export default UserView
